module.exports = import("@fortawesome/pro-duotone-svg-icons/faSpinnerThird");;